/**
 * 租赁业务路由
 */
import store from '@/store'

export default [
  {
    path: '/agreement',
    component: () => import('@/views/User/agreement'),
    name: 'agreement'
  },
  {
    path: '/download',
    component: () => import('@/views/download/index'),
    name: 'download'
  },
  {
    path: '/city',
    component: () => import('@/views/City/index'),
    name: 'city'
  },
  {
    path: '/rental',
    component: () => import('@/views/Home'),
    name: 'rental'
  },
  {
    path: '/refreshs',
    component: () => import('@/demo/refresh'),
    name: 'refresh'
  },
  {
    path: '/err',
    component: () => import('@/views/err/index'),
    name: 'err'
  },
  {
    path: '/cost/',
    component: () => import('@/views/cost/index'),
    name: 'cost'
  },
  {
    path: '/errempty',
    component: () => import('@/views/err/err-empty'),
    name: 'errempty'
  },
  {
    path: '/errnothing',
    component: () => import('@/views/err/err-nothing'),
    name: 'errnothing'
  },
  {
    path: '/list',
    component: () => import('@/views/List/index'),
    name: 'list'
  },
  {
    path: '/pay',
    component: () => import('@/views/Pay/index'),
    children: [
      {
        path: 'wechat',
        component: () => import('@/views/Pay/Wechat'),
        name: 'pay_wechat'
      },
      {
        mode: 'history',
        path: 'alipay',
        component: () => import('@/views/Pay/Alipay'),
        name: 'pay_alipay'
      }
    ]
  },
  {
    path: '/rv/:id',
    component: () => import('@/views/Rv'),
    children: [
      {
        path: '',
        component: () => import('@/views/Rv/Detail'),
        name: 'rv_detail'
      },
      {
        path: 'comment',
        component: () => import('@/views/Rv/Comment'),
        name: 'rv_comment'
      },
      {
        path: 'meta',
        component: () => import('@/views/Rv/Meta'),
        name: 'rv_meta'
      },
      {
        path: 'album',
        component: () => import('@/views/Rv/Album'),
        name: 'rv_album'
      },
      {
        path: 'book',
        component: () => import('@/views/Rv/Book'),
        name: 'rv_book',
        beforeEnter: (to, from, next) => {
          if (!store.getters.isLoggedin) {
            next({
              name: 'rv_detail',
              query: to.query,
              params: to.params
            })
          } else {
            next()
          }
        }
      }
    ]
  },
  {
    path: '/comment/:id',
    component: () => import('@/views/Comment/index'),
    name: 'comment',
    children: [
      {
        path: 'album',
        component: () => import('@/views/Comment/Album'),
        name: 'comment_album'
      }
    ]
  },
  {
    path: '/order/:id',
    component: () => import('@/views/Order/index'),
    children: [
      {
        path: '',
        component: () => import('@/views/Order/Detail'),
        name: 'order_detail'
      },
      {
        path: 'comment',
        component: () => import('@/views/Order/Comment'),
        name: 'order_comment'
      },
      {
        path: 'pay',
        component: () => import('@/views/Order/Pay'),
        name: 'order_pay'
      },
      {
        path: 'evaluate',
        component: () => import('@/views/Order/Evaluate'),
        name: 'order_evaluate'
      }
    ]
  },
  {
    path: '/open_order',
    component: () => import('@/views/Open/Order'),
    name: 'open_order'
  },
  {
    path: '/store/:id',
    component: () => import('@/views/Store/index'),
    name: 'store'
  },
  {
    path: '/agency/:id',
    component: () => import('@/views/agency/index'),
    name: 'agency'
  },
  {
    path: '/page',
    component: () => import('@/views/Page/index'),
    name: 'page'
  },
  {
    path: '/album/:id',
    component: () => import('@/views/Album/index'),
    name: 'album'
  },
  {
    path: '/yunnan',
    component: () => import('@/views/Hotcity/yunnan'),
    name: 'yunnan'
  },
  {
    path: '/neimeng',
    component: () => import('@/views/Hotcity/neimeng'),
    name: 'neimeng'
  },
  {
    path: '/agnecycity',
    component: () => import('@/views/city/ag-city'),
    name: 'agencyCity'
  },
  {
    path: '/discounts',
    component: () => import('@/views/discounts/index'),
    children: [
      {
        path: '',
        component: () => import('@/views/discounts/detail'),
        name: 'discounts_detail'
      },
      {
        path: 'detail',
        component: () => import('@/views/discounts/detail'),
        name: 'discounts_detail'
      },
      {
        path: ':id/get',
        component: () => import('@/views/discounts/get'),
        name: 'discounts_get'
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/rental.js